export default __webpack_public_path__ + "static/media/declaracionjuradamemoria2023.82a84b94-3.54847984.png";